module.exports = __webpack_public_path__ + "assets/img/KRUG_BRASIL__0258-min.e15184c5.jpg";